export const PAGE_SIZE_OPTIONS = [10, 50, 100, 250];

export const PAGINATOR = $localize`%a - %b of %c`;
